import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="container-fluid overflow-hidden about py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
            <div className="about-item">
              <div className="pb-5">
                <h1 className="display-5 text-capitalize">
                  Steward
                  <span className="text-primary">Cars </span>
                </h1>
                <p className="mb-0">
                  Welcome to Steward Cars, your premier car rental service in
                  Kenya. We are committed to providing reliable and affordable
                  transportation solutions tailored to your needs.
                </p>
              </div>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="about-item-inner border p-4">
                    <div className="about-icon mb-4">
                      <img
                        src="img/about-icon-1.png"
                        className="img-fluid w-50 h-50"
                        alt="Vision Icon"
                      />
                    </div>
                    <h5 className="mb-3">Our Vision</h5>
                    <p className="mb-0">
                      To be the leading car rental company in Kenya, known for
                      exceptional service and a diverse fleet.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="about-item-inner border p-4">
                    <div className="about-icon mb-4">
                      <img
                        src="img/about-icon-2.png"
                        className="img-fluid h-50 w-50"
                        alt="Mission Icon"
                      />
                    </div>
                    <h5 className="mb-3">Our Mission</h5>
                    <p className="mb-0">
                      To provide our customers with safe, comfortable, and
                      affordable car rental services across Kenya.
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-item my-4">
                At Steward Cars, we understand that transportation is essential
                for both business and leisure. Our team is dedicated to ensuring
                you have a seamless rental experience.
              </p>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="text-center rounded bg-secondary p-4">
                    <h1 className="display-6 text-white">10+</h1>
                    <h5 className="text-light mb-0">Years Of Experience</h5>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="rounded">
                    <p className="mb-2">
                      <i className="fa fa-check-circle text-primary me-1"></i>{" "}
                      Wide range of vehicles
                    </p>
                    <p className="mb-2">
                      <i className="fa fa-check-circle text-primary me-1"></i>{" "}
                      Flexible rental terms
                    </p>
                    <p className="mb-2">
                      <i className="fa fa-check-circle text-primary me-1"></i>{" "}
                      24/7 customer support
                    </p>
                    <p className="mb-0">
                      <i className="fa fa-check-circle text-primary me-1"></i>{" "}
                      Competitive pricing
                    </p>
                  </div>
                </div>
                <div className="col-lg-5 d-flex align-items-center">
                  <Link to="/" className="btn btn-primary rounded py-3 px-5">
                    More About Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="about-img">
              <div className="img-1">
                <img
                  src="img/about-img.jpg"
                  className="img-fluid rounded h-100 w-100"
                  alt="About Us"
                />
              </div>
              <div className="img-2">
                <img
                  src="img/about-img-1.jpg"
                  className="img-fluid rounded w-100"
                  alt="About Us"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
